import { render, staticRenderFns } from "./DynamicFormEditor.vue?vue&type=template&id=d1afb8b8&scoped=true&"
import script from "./DynamicFormEditor.vue?vue&type=script&lang=js&"
export * from "./DynamicFormEditor.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFormEditor.vue?vue&type=style&index=0&id=d1afb8b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1afb8b8",
  null
  
)

export default component.exports